<template>
  <section id="balao-resposta" class="d-flex align-items-stretch flex-column">
    <h6 class="mt-3 md-body-2 mb-2 align-self-center">Isso foi útil?</h6>
    <div class="d-flex mb-3 align-self-center">
      <md-button class="md-icon-button md-primary">
        <md-icon>thumb_up</md-icon>
      </md-button>
      <md-button class="md-icon-button md-primary">
        <md-icon>thumb_down</md-icon>
      </md-button>
    </div>
    <div class="speech-bubble w-100">
      <h6 class="font-weight-bold md-title mt-0 mb-1">Resposta</h6>
      <p class="m-0 md-body-2">
        {{ texto }}
      </p>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'BalaoResposta',
    props: {
      texto: { default: "Texto" },
    }
  }
</script>

<style lang="scss" scoped>
  $branco-gelo: #f3f3f3;

  .speech-bubble {
    position: relative;
    background: #cc0000;
    border-radius: .4em;
    margin-right: 20px;
    padding: 15px;
    color: #fff;
    filter: drop-shadow(2px 2px 2px rgba(0, 0, 0, 0.27));
  }

  .speech-bubble:after {
    content: '';
    position: absolute;
    right: 0;
    top: 50%;
    width: 0;
    height: 0;
    border: 22px solid transparent;
    border-left-color: #cc0000;
    border-right: 0;
    border-top: 0;
    margin-top: -11px;
    margin-right: -22px;
  }
</style>
